const PANEL_TYPES = {
    WASTE: "w",
    BRIDGE: "b",
};

export default PANEL_TYPES;
